module.exports = __webpack_public_path__ + "static/media/taiwan-cover.6afa3c6c.jpg";